import { Dialog, DialogPanel } from "@headlessui/react";
import useChatDQP from "../../custom-hooks/useChatDQP";
import ChatDQPContent from "./ChatDQPContent";

export default function ChatDQP() {
  const { open, setOpen } = useChatDQP();
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className="relative z-50"
    >
      {/* Backdrop with blur effect only - no darkening */}
      <div
        className="fixed inset-0 backdrop-blur-[2px] transition-all duration-200 data-[closed]:backdrop-blur-0"
        aria-hidden="true"
      />

      {/* Drawer */}
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-6xl transform transition duration-200 ease-in-out data-[closed]:translate-x-full"
            >
              <div className="flex h-full flex-col bg-white shadow-xl">
                <ChatDQPContent setOpen={setOpen} />
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
